import { types } from 'mobx-state-tree';

export const DepthAndWorkMethodBlockModel = types
  .model('DepthAndWorkMethodBlockModel', {
    workMethod: types.maybe(types.array(types.integer)),
    depth: types.maybe(types.number)
  })
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        const keyValue = changedValues[key];
        if (keyValue === '' || keyValue === null) {
          self[key] = undefined;
        } else if (key === 'depth') {
          if (!isNaN(keyValue) && keyValue !== null && keyValue.toString().slice(-1) !== '.') {
            self[key] = keyValue;
          }
        } else {
          self[key] = changedValues[key];
        }
      }
    }
  }));
